module.exports = __webpack_public_path__ + "trash_delete_black_white_14_16.d6c78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/trash_delete_black_white_14_16.svg
// module id = ./src/_asset/sources/assets/images/@svg/trash_delete_black_white_14_16.svg
// module chunks = main